import './TaskSection.scss';
import { BarsOutlined } from '@ant-design/icons';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { coreActions } from '@sonar-software/sonar-core';
import { CreateTask } from './CreateTask';
import { DeleteTaskNotification } from './DeleteTaskNotification';
import { InitiativeSection } from '../general';
import { InitiativeTask } from './Task';
import React from 'react';
import { UpdateTaskNotification } from './UpdateTaskNotification';
import { DragDropContext, Droppable, DropResult } from 'react-beautiful-dnd';
import { useAction, useInitiativeTasks } from '@hooks';

export interface TaskSectionProps {
	initiativeId: number;
}

export const TaskSection: React.FC<TaskSectionProps> = ({ initiativeId }) => {
	const { tasks } = useInitiativeTasks(initiativeId, true);

	const orderTasks = useAction(coreActions.requestPostCoreInitiativesTasksOrder);

	const handleOnDragEnd = (dropResult: DropResult) => {
		const { destination, source } = dropResult;

		if (!source || !destination) {
			return;
		}

		orderTasks({
			initiativeId,
			sourceIndex: source.index,
			targetIndex: destination.index
		});
	};

	return (
		<InitiativeSection
			count={ tasks?.length }
			icon={ <BarsOutlined /> }
			id='initiative-tasks-section'
			title={ COPY_SPECIFIC.TASKS }>
			<DragDropContext onDragEnd={ handleOnDragEnd }>
				<Droppable droppableId='tasks'>
					{ (provided) =>
						<div
							ref={ provided.innerRef }
							{ ...provided.droppableProps }>
							{ tasks?.map((task, index) => {
								const { initiativeTaskId } = task;

								return <InitiativeTask
									index={ index }
									key={ initiativeTaskId }
									task={ task } />;
							}) }
							{ provided.placeholder }
						</div> }
				</Droppable>
			</DragDropContext>
			<CreateTask initiativeId={ initiativeId } />
			<DeleteTaskNotification />
			<UpdateTaskNotification />
		</InitiativeSection>
	);
};
